export default class SurveysQuestionsFormStepTwo {

  constructor() {}

  render() {

    // Display previous on select
    $('#answerRequired').change(function() {
      if ($(this).is(':checked')) {
        $('.dependent-previous-question').removeClass('d-none');
      } else {
        $('.dependent-previous-question').addClass('d-none');        
      }
    })

  }
}
